// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"112":"work","420":"message","539":"misc","644":"account","857":"report","884":"admin"}[chunkId] || chunkId) + "." + {"112":"10b7e83b","368":"84e95fdb","420":"ac42c22d","516":"b90e05b7","539":"52595948","644":"47fb0308","857":"6b4a0747","884":"fa522708","945":"6b5f1285"}[chunkId] + ".js";
};